module.exports = __webpack_public_path__ + "static/media/expand-wide.d19a5525.svg";